<template>
  <ProductBanner
    v-if="isExclusive"
    :content="$t('product.tag.exclusive')"
    color="white"
    background="primary"
    over-image
    medium
    class="badge px-4"
  />
  <ProductBanner
    v-else-if="isNew"
    :content="$t('label.new')"
    color="white"
    background="primary"
    over-image
    medium
    class="badge px-4"
  />
</template>

<script lang="ts" setup>
import ProductBanner from '~/components/base/ProductBanner.vue'
import type { ListedProduct as Product } from '~/types/shop'

interface Props {
  product?: Product | null
}
const props = withDefaults(defineProps<Props>(), {
  product: null
})

const isNew = computed(() => {
  return props.product?.isNew || false
})

const isExclusive = computed(() => {
  return props.product?.productOfTheMonth || false
})
</script>

<style lang="scss" scoped>
.badge {
  border-radius: 20px;
  min-width: fit-content;
}
</style>
